import API_BASE_URL, { getEffectiveTenantHost } from '../config';

interface BugReportMetadata {
  tenant?: string;
  environment?: string;
  userEmail?: string;
}

export interface BugReportCaptcha {
  challengeId: string;
  num1: number;
  num2: number;
  operator: '+' | '-' | '*';
}

const bugReportService = {
  async getCaptcha(): Promise<BugReportCaptcha> {
    const res = await fetch(`${API_BASE_URL}/api/bugreport/captcha`, {
      method: 'GET',
      headers: {
        ...(typeof window !== 'undefined'
          ? { 'X-Forwarded-Host': getEffectiveTenantHost() }
          : {}),
      },
    });
    if (!res.ok) {
      throw new Error('Failed to load captcha');
    }
    const data = await res.json();
    return {
      challengeId: data.challengeId,
      num1: data.num1,
      num2: data.num2,
      operator: data.operator,
    };
  },

  async submitReport(
    text: string,
    captchaChallengeId: string,
    captchaAnswer: number,
    images?: string[],
    metadata?: BugReportMetadata
  ): Promise<boolean> {
    const res = await fetch(`${API_BASE_URL}/api/bugreport/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(typeof window !== 'undefined'
          ? { 'X-Forwarded-Host': getEffectiveTenantHost() }
          : {}),
      },
      body: JSON.stringify({
        text,
        captchaChallengeId,
        captchaAnswer,
        images: images || [],
        tenant: metadata?.tenant,
        environment: metadata?.environment,
        userEmail: metadata?.userEmail
      })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.error?.message || 'Failed to submit bug report');
    }
    const data = await res.json();
    return !!data?.ok;
  }
};

export default bugReportService;